import setCookie from '@/utils/setCookie.js';

export default function (element, data) {  
  if (data.cities) {
    const cities = data.cities;
  
    function success(position) {
      const lat = position.coords.latitude;
      const lon = position.coords.longitude;

      let closestCity = null;
      let minDistance = Infinity;
    
      cities.forEach(city => {
        const distance = Math.sqrt(
          Math.pow(city.lat - lat, 2) +
          Math.pow(city.lon - lon, 2)
        );
    
        if (distance < minDistance) {
          minDistance = distance;
          closestCity = city;
        }
      });
    
      if (closestCity && closestCity.url) {
        setCookie('located', '1', {
          expires: new Date(Date.now() + 30 * 24 * 60 * 60 * 1000),
          path: '/',
          secure: false,
          samesite: 'Strict'
        });

        window.location.assign(closestCity.url);
      }
    }
  
    function error() {
      console.error("Unable to retrieve your location");
    }
  
    if (!navigator.geolocation) {
      console.error("Geolocation is not supported by your browser");
    } else {
      console.log("Locating…");
      navigator.geolocation.getCurrentPosition(success, error);
    }
  }
}
